"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./getEnvironmentFromHostname.cjs");function n(){return e.getEnvironmentFromHostname()==="levelbuilder"}exports.isLevelbuilderEnvironment=n;
//# sourceMappingURL=isLevelbuilderEnvironment.cjs.map
